
/* injects from baggage-loader */

'use strict';

export default function(app) {
  app.filter('fang', UtilsService => function(value) {
      if (!value) {
        return '';
      }

      return UtilsService.fangValue(value);
    });
}



// WEBPACK FOOTER //
// ./src/app/core/filters/fang.js